.container {
  container-type: inline-size;
}

.picker {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-20);
  color: var(--zumpo-ink);
}

.controls {
  display: flex;
  flex-wrap: wrap;
  gap: var(--zumpo-space-32);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-8);
}

.label {
  color: var(--zumpo-muted);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.stepper {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-8);
}

.count {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  font: var(--zumpo-text-title);
  letter-spacing: var(--zumpo-text-title-tracking);
}

.faces {
  display: flex;
  gap: var(--zumpo-space-8);
}

.face {
  display: flex;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--zumpo-radius-12);
  background: none;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

/* Hover rings the die inside its edge, so nothing moves. */
.face:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.face:hover:not(:disabled) > span {
  box-shadow: inset 0 0 0 2px var(--zumpo-ink);
}

.face:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--zumpo-space-12);
}

/* Narrower than the row's 518px, as on a phone: the controls stack and the
   two actions share the width. */
@container (width < 518px) {
  /* Single-line, or the stacked fields would be as wide as the row of faces
     rather than the picker. */
  .controls {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: var(--zumpo-space-16);
  }

  /* As wide as the picker, so the faces know what they have to fit. */
  .field {
    min-width: 0;
  }

  .actions > * {
    flex: 1;
  }
}
